export function isOpenFin() {
    const regexp = /OpenFin/;
    return regexp.test(navigator.userAgent);
}
